module.exports = __webpack_public_path__ + "static/media/33.77a6a3d3.jpg";